import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { Timer } from "three/addons/misc/Timer.js";
import { Sky } from 'three/addons/objects/Sky.js'
import GUI from "lil-gui";

/**
 * Base
 */
// Debug
const gui = new GUI();

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Textures
 */

const textureLoader = new THREE.TextureLoader()

// floor
const floorAlphaTexture = textureLoader.load('/haunted_house_textures/floor/alpha.jpg')
const floorColorTexture = textureLoader.load('/haunted_house_textures/floor/aerial_rocks_01_1k/aerial_rocks_01_diff_1k.webp')
const floorARMTexture = textureLoader.load('/haunted_house_textures/floor/aerial_rocks_01_1k/aerial_rocks_01_arm_1k.webp')
const floorNormalTexture = textureLoader.load('/haunted_house_textures/floor/aerial_rocks_01_1k/aerial_rocks_01_nor_gl_1k.webp')
const floorDisplacementTexture = textureLoader.load('/haunted_house_textures/floor/aerial_rocks_01_1k/aerial_rocks_01_disp_1k.webp')

floorColorTexture.repeat.set(8, 8)
floorARMTexture.repeat.set(8, 8)
floorNormalTexture.repeat.set(8, 8)
floorDisplacementTexture.repeat.set(8, 8)

floorColorTexture.wrapS = THREE.RepeatWrapping
floorARMTexture.wrapS = THREE.RepeatWrapping
floorNormalTexture.wrapS = THREE.RepeatWrapping
floorDisplacementTexture.wrapS = THREE.RepeatWrapping
floorColorTexture.wrapT = THREE.RepeatWrapping
floorARMTexture.wrapT = THREE.RepeatWrapping
floorNormalTexture.wrapT = THREE.RepeatWrapping
floorDisplacementTexture.wrapT = THREE.RepeatWrapping
floorColorTexture.colorSpace = THREE.SRGBColorSpace

// Walls

const wallColorTexture = textureLoader.load('/haunted_house_textures/walls/castle_brick_broken_06_1k/castle_brick_broken_06_diff_1k.webp')
const wallARMTexture = textureLoader.load('/haunted_house_textures/walls/castle_brick_broken_06_1k/castle_brick_broken_06_arm_1k.webp')
const wallNormalTexture = textureLoader.load('/haunted_house_textures/walls/castle_brick_broken_06_1k/castle_brick_broken_06_nor_gl_1k.webp')

wallColorTexture.wrapS = THREE.RepeatWrapping
wallARMTexture.wrapS = THREE.RepeatWrapping
wallNormalTexture.wrapS = THREE.RepeatWrapping
wallColorTexture.wrapT = THREE.RepeatWrapping
wallARMTexture.wrapT = THREE.RepeatWrapping
wallNormalTexture.wrapT = THREE.RepeatWrapping
wallColorTexture.colorSpace = THREE.SRGBColorSpace

// Roof

const roofColorTexture = textureLoader.load('/haunted_house_textures/roof/grey_roof_tiles_02_1k/grey_roof_tiles_02_diff_1k.webp')
const roofARMTexture = textureLoader.load('/haunted_house_textures/roof/grey_roof_tiles_02_1k/grey_roof_tiles_02_arm_1k.webp')
const roofNormalTexture = textureLoader.load('/haunted_house_textures/roof/grey_roof_tiles_02_1k/grey_roof_tiles_02_nor_gl_1k.webp')

roofColorTexture.wrapS = THREE.RepeatWrapping
roofARMTexture.wrapS = THREE.RepeatWrapping
roofNormalTexture.wrapS = THREE.RepeatWrapping
roofColorTexture.wrapT = THREE.RepeatWrapping
roofARMTexture.wrapT = THREE.RepeatWrapping
roofNormalTexture.wrapT = THREE.RepeatWrapping
roofColorTexture.colorSpace = THREE.SRGBColorSpace

roofColorTexture.repeat.set(5, 1)
roofARMTexture.repeat.set(5, 1)
roofNormalTexture.repeat.set(5, 1)

roofColorTexture.repeatS = THREE.RepeatWrapping
roofARMTexture.repeatS = THREE.RepeatWrapping
roofNormalTexture.repeatS = THREE.RepeatWrapping

// Bushes

const bushesColorTexture = textureLoader.load('/haunted_house_textures/bushes/leaves_forest_ground_1k/leaves_forest_ground_diff_1k.webp')
const bushesARMTexture = textureLoader.load('/haunted_house_textures/bushes/leaves_forest_ground_1k/leaves_forest_ground_arm_1k.webp')
const bushesNormalTexture = textureLoader.load('/haunted_house_textures/bushes/leaves_forest_ground_1k/leaves_forest_ground_nor_gl_1k.webp')

bushesColorTexture.wrapS = THREE.RepeatWrapping
bushesARMTexture.wrapS = THREE.RepeatWrapping
bushesNormalTexture.wrapS = THREE.RepeatWrapping
bushesColorTexture.wrapT = THREE.RepeatWrapping
bushesARMTexture.wrapT = THREE.RepeatWrapping
bushesNormalTexture.wrapT = THREE.RepeatWrapping
bushesColorTexture.colorSpace = THREE.SRGBColorSpace

// Grave
const graveColorTexture = textureLoader.load('/haunted_house_textures/grave/plastered_stone_wall_1k/plastered_stone_wall_diff_1k.webp')
const graveARMTexture = textureLoader.load('/haunted_house_textures/grave/plastered_stone_wall_1k/plastered_stone_wall_arm_1k.webp')
const graveNormalTexture = textureLoader.load('/haunted_house_textures/grave/plastered_stone_wall_1k/plastered_stone_wall_nor_gl_1k.webp')

graveColorTexture.wrapS = THREE.RepeatWrapping
graveARMTexture.wrapS = THREE.RepeatWrapping
graveNormalTexture.wrapS = THREE.RepeatWrapping
graveColorTexture.wrapT = THREE.RepeatWrapping
graveARMTexture.wrapT = THREE.RepeatWrapping
graveNormalTexture.wrapT = THREE.RepeatWrapping
graveColorTexture.colorSpace = THREE.SRGBColorSpace

graveColorTexture.repeat.set(0.3, 0.4)
graveARMTexture.repeat.set(0.3, 0.4)
graveNormalTexture.repeat.set(0.3, 0.4)

// Door

const doorColorTexture = textureLoader.load('/haunted_house_textures/door/color.jpg')
const doorAlphaTexture = textureLoader.load('/haunted_house_textures/door/alpha.jpg')
const doorAmbientOcclusionTexture = textureLoader.load('/haunted_house_textures/door/ambientOcclusion.jpg')
const doorHeightTexture = textureLoader.load('/haunted_house_textures/door/height.jpg')
const doorNormalTexture = textureLoader.load('/haunted_house_textures/door/normal.jpg')
const doorMetalnessTexture = textureLoader.load('/haunted_house_textures/door/metalness.jpg')
const doorRoughnessTexture = textureLoader.load('/haunted_house_textures/door/roughness.jpg')
doorColorTexture.colorSpace = THREE.SRGBColorSpace

/**
 * House
 */

// Floor
const floor = new THREE.Mesh(
	new THREE.PlaneGeometry(20, 20, 100, 100),
	new THREE.MeshStandardMaterial({
        alphaMap: floorAlphaTexture,
        transparent: true,
        map: floorColorTexture,
        aoMap: floorARMTexture,
        roughnessMap: floorARMTexture,
        metalnessMap: floorARMTexture,
        normalMap: floorNormalTexture,
        displacementMap: floorDisplacementTexture,
        displacementScale: 0.1,
        displacementBias: -0.034
    })
);
floor.rotation.x = -Math.PI * 0.5;
scene.add(floor);

gui.add(floor.material, 'displacementScale').min(0).max(1).step(0.001).name('floorDisplacementScale')
gui.add(floor.material, 'displacementBias').min(-1).max(1).step(0.001).name('floorDisplacementBias')

// House

const houseGroup = new THREE.Group();
scene.add(houseGroup);

// Walls
const walls = new THREE.Mesh(
	new THREE.BoxGeometry(4, 2.5, 4),
	new THREE.MeshStandardMaterial({
        map: wallColorTexture,
        aoMap: wallARMTexture,
        roughnessMap: wallARMTexture,
        metalnessMap: wallARMTexture,
        normalMap: wallNormalTexture,
    })
);
walls.position.y += 2.5 / 2;

houseGroup.add(walls);

// Roof
const roof = new THREE.Mesh(
	new THREE.ConeGeometry(3.5, 1.5, 4),
	new THREE.MeshStandardMaterial({
        map: roofColorTexture,
        aoMap: roofARMTexture,
        roughnessMap: roofARMTexture,
        metalnessMap: roofARMTexture,
        normalMap: roofNormalTexture,
    })
);
roof.position.y = 2.5 + 1.5 / 2;
roof.rotation.y = Math.PI * 0.25;

houseGroup.add(roof);

// Door

const door = new THREE.Mesh(
	new THREE.PlaneGeometry(2.2, 2.2, 100, 100),
	new THREE.MeshStandardMaterial({
        map: doorColorTexture,
        transparent: true,
        alphaMap: doorAlphaTexture,
        aoMap: doorAmbientOcclusionTexture,
        displacementMap: doorHeightTexture,
        normalMap: doorNormalTexture,
        metalnessMap: doorMetalnessTexture,
        roughnessMap: doorRoughnessTexture,
        displacementScale: 0.02,
        displacementBias: -0.04,
    })
);
door.position.y = 1;
door.position.z = 2 + 0.05;
houseGroup.add(door);

// Bushes

const bushGeometry = new THREE.SphereGeometry(1, 16, 16);
const bushMaterial = new THREE.MeshStandardMaterial({
    color: 0xccffcc,
    map: bushesColorTexture,
    aoMap: bushesARMTexture,
    roughnessMap: bushesARMTexture,
    metalnessMap: bushesARMTexture,
    normalMap: bushesNormalTexture,
});

const bush1 = new THREE.Mesh(bushGeometry, bushMaterial);
bush1.position.set(0.8, 0.2, 2.2)
bush1.scale.set(0.5, 0.5, 0.5)
bush1.rotation.x = -0.75
houseGroup.add(bush1)

const bush2 = new THREE.Mesh(bushGeometry, bushMaterial);
bush2.position.set(1.4, 0.1, 2.1)
bush2.scale.setScalar(0.25)
bush2.rotation.x = -0.75
houseGroup.add(bush2)

const bush3 = new THREE.Mesh(bushGeometry, bushMaterial);
bush3.position.set(-0.8, 0.2, 2.2)
bush3.scale.setScalar(0.4)
bush3.rotation.x = -0.75
houseGroup.add(bush3)

const bush4 = new THREE.Mesh(bushGeometry, bushMaterial);
bush4.position.set(-1, 0.05, 2.6)
bush4.scale.setScalar(0.15)
bush4.rotation.x = -0.75
houseGroup.add(bush4)

houseGroup.add(bush1, bush2, bush3, bush4)

// Graves

const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2)
const graveMaterial = new THREE.MeshStandardMaterial({
    map: graveColorTexture,
    aoMap: graveARMTexture,
    roughnessMap: graveARMTexture,
    metalnessMap: graveARMTexture,
    normalMap: graveNormalTexture,
})
const gravesGroup = new THREE.Group()
scene.add(gravesGroup)

for(let i = 0; i < 30; i ++) {
    const angle = Math.random() * Math.PI * 2
    const radius = 3 + Math.random() * 5
 
    const x = Math.sin(angle) * radius
    const z = Math.cos(angle) * radius

    const grave = new THREE.Mesh(graveGeometry, graveMaterial)
    grave.position.x = x
    grave.position.y = 0.1 + Math.random() * 0.3
    grave.position.z = z

    grave.rotation.x = (Math.random() - 0.5) * 0.2
    grave.rotation.z = (Math.random() - 0.5) * 0.2
    grave.rotation.y = Math.random() * Math.PI * 2
    gravesGroup.add(grave)
}

const doorLightBulb = new THREE.Mesh(
    new THREE.SphereGeometry(0.05),
    new THREE.MeshPhysicalMaterial({
        metalness: 0,
        roughness: 0.5,
        transmission: 1,
        ior: 1.5,
        thickness: 1.5
    })
)
doorLightBulb.rotation.x = Math.PI * 0.5
doorLightBulb.rotation.z = Math.PI * 0.5
doorLightBulb.position.set(0, 2.48, 2.25)
houseGroup.add(doorLightBulb)

/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight("#86cdff", 0.275);
scene.add(ambientLight);

// Directional light
const directionalLight = new THREE.DirectionalLight("#86cdff", 1);
directionalLight.position.set(3, 2, -8);
scene.add(directionalLight);

const doorLight = new THREE.PointLight('#ff7d46', 5)
doorLight.position.x = doorLightBulb.position.x
doorLight.position.y = doorLightBulb.position.y
doorLight.position.z = doorLightBulb.position.z
houseGroup.add(doorLight)


// Ghosts
const ghost1 = new THREE.PointLight('#8800FF', 6)
const ghost2 = new THREE.PointLight('#FF0088', 6)
const ghost3 = new THREE.PointLight('#FF0000', 6)

scene.add(ghost1, ghost2, ghost3)

/**
 * Sizes
 */
const sizes = {
	width: window.innerWidth,
	height: window.innerHeight,
};

window.addEventListener("resize", () => {
	// Update sizes
	sizes.width = window.innerWidth;
	sizes.height = window.innerHeight;

	// Update camera
	camera.aspect = sizes.width / sizes.height;
	camera.updateProjectionMatrix();

	// Update renderer
	renderer.setSize(sizes.width, sizes.height);
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
	75,
	sizes.width / sizes.height,
	0.1,
	100
);
camera.position.x = 4;
camera.position.y = 2;
camera.position.z = 5;
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
	canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Shadows
 */

renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap

directionalLight.castShadow = true
ghost1.castShadow = true
ghost2.castShadow = true
ghost3.castShadow = true

walls.castShadow = true
walls.receiveShadow = true
floor.receiveShadow = true

roof.castShadow = true
roof.receiveShadow = true

for(const grave of gravesGroup.children) {
    grave.castShadow = true
    grave.receiveShadow = true
}

// Mappings
directionalLight.shadow.mapSize.width = 256
directionalLight.shadow.mapSize.height = 256
directionalLight.shadow.camera.top = 8
directionalLight.shadow.camera.right = 8
directionalLight.shadow.camera.bottom = - 8
directionalLight.shadow.camera.left = - 8
directionalLight.shadow.camera.near = 1
directionalLight.shadow.camera.far = 20

ghost1.shadow.mapSize.width = 256
ghost1.shadow.mapSize.height = 256
ghost1.shadow.camera.far = 10

ghost2.shadow.mapSize.width = 256
ghost2.shadow.mapSize.height = 256
ghost2.shadow.camera.far = 10

ghost3.shadow.mapSize.width = 256
ghost3.shadow.mapSize.height = 256
ghost3.shadow.camera.far = 10

/**
 * Sky
 */

const sky = new Sky()
sky.scale.set(100, 100, 100)
scene.add(sky)

sky.material.uniforms['turbidity'].value = 10
sky.material.uniforms['rayleigh'].value = 3
sky.material.uniforms['mieCoefficient'].value = 0.1
sky.material.uniforms['mieDirectionalG'].value = 0.95
sky.material.uniforms['sunPosition'].value.set(0.3, -0.038, -0.95)

/**
 * Fog
 */
// scene.fog = new THREE.Fog('#04343f', 1, 13)
scene.fog = new THREE.FogExp2('#04343f', 0.1)

/**
 * Animate
 */
const timer = new Timer();

const tick = () => {
	// Timer
	timer.update();
	const elapsedTime = timer.getElapsed();

    ghost1.position.x = 4 * Math.cos(elapsedTime * 0.5)
    ghost1.position.z = 4 * Math.sin(elapsedTime * 0.5)
    ghost1.position.y = 1.5 * Math.sin(elapsedTime * 2) * Math.sin(elapsedTime * 3) * Math.sin(elapsedTime * 1.5)


    ghost2.position.x = - 5.5 * Math.cos(elapsedTime * 0.3 + 2)
    ghost2.position.z = 4 * Math.sin(elapsedTime * 0.2 + 2)
    ghost2.position.y = 1 + 1.5 * Math.sin(elapsedTime * 1.2+ 3) * Math.sin(elapsedTime * 1.8)

    ghost3.position.x = - 7 * Math.cos(elapsedTime * 0.3 + 2)
    ghost3.position.z = 6 * Math.sin(elapsedTime * 0.6 + 2)
    ghost3.position.y = 1 + 1.5 * Math.sin(elapsedTime * 1.2+ 3) * Math.sin(elapsedTime * 1.8)

    // Doorlight flicker
    const intensity = 3 * Math.abs(Math.random() * Math.cos(5 * elapsedTime) * Math.sin(4 * elapsedTime)) * (Math.sin(3 * elapsedTime)) + 2
    doorLight.intensity = intensity

	// Update controls
	controls.update();

	// Render
	renderer.render(scene, camera);

	// Call tick again on the next frame
	window.requestAnimationFrame(tick);
};

tick();
